// import React from 'react';
// import { useTeams } from '../hooks/useTeams';
// import { TeamStats } from '../components/TeamStats';
// import { FilterSection } from '../../../components/ui/FilterSection';
// import { DataTable } from '../../../components/ui/DataTable';
// import { Pagination } from '../../../components/ui/Pagination';
// import { AddEmployeeModal } from '../components/AddEmployeeModal';
// import { ViewEmployeeModal } from '../components/ViewEmployeeModal';
// import { Eye, Pencil, UserCheck, UserX } from 'lucide-react';
// import { Toast } from '../../../components/ui/Toast';
// import { TeamGridView } from '../components/TeamGridView';
// import { formatTeamRoleLabel, formatInstallationTrade } from '../utils/teamMemberLabels';

// const ROLE_FILTER_OPTIONS = [
//   { label: 'All roles', value: 'All Roles' },
//   { label: 'Project Manager', value: 'project-manager' },
//   { label: 'Installation member', value: 'field_officer' },
//   { label: 'Accountant', value: 'accountant' },
//   { label: 'Store Incharge', value: 'store-manager' }
// ];

// export const TeamsScreen = () => {
//   const {
//     showDetails,
//     setShowDetails,
//     searchQuery,
//     handleSearch,
//     roleFilter,
//     handleRoleFilter,
//     installationTradeFilter,
//     handleInstallationTradeFilter,
//     tradeFilterOptions,
//     dateRange,
//     datePreset,
//     handleStartDateChange,
//     handleEndDateChange,
//     handleDatePreset,
//     teamModalOpen,
//     openCreateModal,
//     openEditEmployee,
//     closeModal,
//     editingEmployee,
//     viewMode,
//     setViewMode,
//     isLoading,
//     handleEmployeeSubmit,
//     toggleMemberStatus,
//     handlePageChange,
//     employees,
//     stats,
//     page,
//     totalPages,
//     totalItems,
//     toast,
//     setToast,
//     viewingEmployee,
//     setViewingEmployee,
//     refetchTeams
//   } = useTeams();

//   const tableColumns = [
//     {
//       header: 'Employee ID',
//       minWidth: '100px',
//       accessor: (row) => (
//         <span className="text-[12px] text-slate-500 tracking-tight">{row.employeeId}</span>
//       )
//     },
//     {
//       header: 'Employee Name',
//       minWidth: '200px',
//       accessor: (row) => (
//         <div className="flex items-center gap-2.5 min-w-0">
//           <div className="w-7 h-7 rounded-xl bg-[#2b448f] text-white flex items-center justify-center font-bold text-[1opx] shrink-0">
//             {row.firstName?.substring(0, 1) || 'U'}
//           </div>
//           <div className="flex flex-col min-w-0">
//             <span className="font-medium text-slate-700 text-[12px] truncate">
//               {row.firstName || 'Unknown'} {row.lastName || ''}
//             </span>
//             <span className="text-[11px] text-slate-400 font-medium truncate">{row.email || '—'}</span>
//           </div>
//         </div>
//       )
//     },
//     {
//       header: 'Role',
//       minWidth: '140px',
//       accessor: (row) => (
//         <div className="flex flex-col gap-0.5">
//           <span className="inline-flex w-fit items-center px-2 py-0.5 rounded-md text-[12px]  bg-[#2b448f]/10 text-[#2b448f] border border-[#2b448f]/20">
//             {formatTeamRoleLabel(row.role)}
//           </span>
//           {row.role === 'field_officer' && (
//             <span className="text-[9px] font-bold text-slate-400">{formatInstallationTrade(row.installationTrade)}</span>
//           )}
//         </div>
//       )
//     },
//     {
//       header: 'Phone',
//       minWidth: '100px',
//       accessor: (row) => <span className="text-[12px] font-medium text-slate-600 whitespace-nowrap">{row.phone}</span>
//     },
//     {
//       header: 'Work Location',
//       minWidth: '120px',
//       accessor: (row) => (
//         <span className="text-[12px] font-medium text-slate-600 truncate block max-w-[140px]">{row.workLocation}</span>
//       )
//     },
//     {
//       header: 'Status',
//       minWidth: '100px',
//       accessor: (row) => (
//         <span
//           className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[12px] font-medium border ${
//             row.status === 'Active'
//               ? 'bg-emerald-50 text-emerald-600 border-emerald-100'
//               : 'bg-slate-50 text-slate-400 border-slate-100'
//           }`}
//         >
//           {row.status}
//         </span>
//       )
//     }
//   ];

//   const ActionCell = ({ row }) => {
//     const inactive = row.status === 'Inactive';
//     return (
//       <div className="flex items-center justify-end gap-0.5 shrink-0">
//         <button
//           type="button"
//           disabled={inactive}
//           onClick={() => !inactive && setViewingEmployee(row)}
//           className={`p-1.5 cursor-pointer rounded-lg transition-all duration-300 ease-in-out ${
//             inactive
//               ? 'text-slate-300/50 cursor-not-allowed opacity-40 pointer-events-none'
//               : 'text-slate-300 hover:text-[#2b448f] hover:bg-slate-50'
//           }`}
//           title={inactive ? 'Disabled for inactive members' : 'View'}
//         >
//           <Eye className="w-3.5 h-3.5" />
//         </button>
//         <button
//           type="button"
//           disabled={inactive}
//           onClick={() => !inactive && openEditEmployee(row)}
//           className={`p-1.5 cursor-pointer rounded-lg transition-all duration-300 ease-in-out ${
//             inactive
//               ? 'text-slate-300/50 cursor-not-allowed opacity-40 pointer-events-none'
//               : 'text-slate-300 hover:text-orange-500 hover:bg-slate-50'
//           }`}
//           title={inactive ? 'Disabled for inactive members' : 'Edit'}
//         >
//           <Pencil className="w-3.5 h-3.5" />
//         </button>
//         {row.status === 'Active' ? (
//           <button
//             type="button"
//             onClick={() => toggleMemberStatus(row)}
//             className="p-1.5 text-slate-300 cursor-pointer hover:text-rose-600 hover:bg-rose-50 rounded-lg transition-all duration-300 ease-in-out"
//             title="Disable member"
//           >
//             <UserX className="w-3.5 h-3.5" />
//           </button>
//         ) : (
//           <button
//             type="button"
//             onClick={() => toggleMemberStatus(row)}
//             className="p-1.5 text-emerald-600 cursor-pointer hover:text-emerald-700 hover:bg-emerald-50 rounded-lg transition-all duration-300 ease-in-out"
//             title="Enable member"
//           >
//             <UserCheck className="w-3.5 h-3.5" />
//           </button>
//         )}
//       </div>
//     );
//   };

//   const columnsWithActions = [
//     ...tableColumns,
//     {
//       header: 'Actions',
//       minWidth: '132px',
//       accessor: (row) => <ActionCell row={row} />
//     }
//   ];

//   return (
//     <div className="flex flex-col gap-3 w-full min-w-0 max-w-full animate-in fade-in duration-500 relative">
//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}

//       <TeamStats showDetails={showDetails} onToggle={() => setShowDetails(!showDetails)} stats={stats} />

//       <div className="flex flex-col rounded-xl overflow-hidden border border-slate-100 bg-white min-w-0">
//         <FilterSection
//           search={searchQuery}
//           setSearch={handleSearch}
//           addLabel="Add Team"
//           onAddClick={openCreateModal}
//           viewStyle={viewMode}
//           setViewStyle={setViewMode}
//           filters={{
//             fromDate: dateRange.from,
//             toDate: dateRange.to,
//             date: datePreset
//           }}
//           setFilters={(key, val) => {
//             if (key === 'fromDate') handleStartDateChange(val);
//             if (key === 'toDate') handleEndDateChange(val);
//             if (key === 'date') handleDatePreset(val);
//           }}
//         >
//           {/* Custom Dropdown Filters */}
//           <div className="flex items-center gap-2 bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0">
//             <span className="text-[12px] font-medium text-slate-500 pl-1">Role</span>
//             <select
//               className="text-[12px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-500 min-w-[120px]"
//               value={roleFilter}
//               onChange={(e) => handleRoleFilter(e.target.value)}
//             >
//               {ROLE_FILTER_OPTIONS.map((opt) => (
//                 <option key={opt.value} value={opt.value}>
//                   {opt.label}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="flex items-center gap-2 bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0">
//             <span className="text-[12px] font-medium text-slate-500 pl-1">Installation type</span>
//             <select
//               className="text-[12px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-500 min-w-[120px]"
//               value={installationTradeFilter}
//               onChange={(e) => handleInstallationTradeFilter(e.target.value)}
//             >
//               {tradeFilterOptions.map((opt) => (
//                 <option key={opt.value} value={opt.value}>
//                   {opt.label}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </FilterSection>

//       </div>
//         {viewMode === 'list' ? (
//           <div className="min-w-0 overflow-x-auto">
//             <DataTable
//               columns={columnsWithActions}
//               data={employees}
//               isLoading={isLoading}
//               isRowInactive={(row) => row.status === 'Inactive'}
//               getRowClassName={(row) =>
//                 row.status === 'Inactive'
//                   ? 'bg-slate-100/90 border-y border-slate-200/80'
//                   : 'hover:bg-slate-50/50'
//               }
//             />
//           </div>
//         ) : (
//           <TeamGridView
//             data={employees}
//             isLoading={isLoading}
//             onView={(emp) => setViewingEmployee(emp)}
//             onEdit={(emp) => openEditEmployee(emp)}
//             onToggleStatus={(emp) => toggleMemberStatus(emp)}
//           />
//         )}

//         <div className="border-t border-slate-50 bg-white">
//           <Pagination
//             page={page}
//             totalPages={totalPages}
//             totalItems={totalItems}
//             onPageChange={handlePageChange}
//           />
//         </div>

//       {teamModalOpen && (
//         <AddEmployeeModal
//           key={editingEmployee?._id || 'create'}
//           isOpen
//           onClose={closeModal}
//           onSubmit={handleEmployeeSubmit}
//           isLoading={isLoading}
//           initialData={editingEmployee}
//         />
//       )}

//       <ViewEmployeeModal
//         employee={viewingEmployee}
//         onClose={() => setViewingEmployee(null)}
//         onEmployeeUpdated={(updated) => {
//           setViewingEmployee((prev) => (prev && updated ? { ...prev, ...updated } : prev));
//           refetchTeams();
//         }}
//       />
//     </div>
//   );
// };

import React from "react";
import { useTeams } from "../hooks/useTeams";
import { TeamStats } from "../components/TeamStats";
import { FilterSection } from "../../../components/ui/FilterSection";
import { DataTable } from "../../../components/ui/DataTable";
import { Pagination } from "../../../components/ui/Pagination";
import { TableActions } from "../../../components/ui/TableActions";
import { AddEmployeeModal } from "../components/AddEmployeeModal";
import { ViewEmployeeModal } from "../components/ViewEmployeeModal";
import { Toast } from "../../../components/ui/Toast";
import { TeamGridView } from "../components/TeamGridView";
import {
  formatTeamRoleLabel,
  formatInstallationTrade,
  getRoleBadgeStyle,
} from "../utils/teamMemberLabels";
import { TABLE_BACKGROUNDS } from "../../../constants/tableBackgrounds";

const ROLE_FILTER_OPTIONS = [
  { label: "All roles", value: "All Roles" },
  { label: "Owner", value: "owner" },
  { label: "Admin", value: "admin" },
  { label: "Project Manager", value: "project-manager" },
  { label: "Installation member", value: "field_officer" },
  { label: "Accountant", value: "accountant" },
  { label: "Store Incharge", value: "store-manager" },
  { label: "Telecaller", value: "telecaller" },
  { label: "Designer", value: "designer" },
  { label: "Sales Executive", value: "sales_executive" },
];

export const TeamsScreen = () => {
  const {
    showDetails,
    setShowDetails,
    searchQuery,
    handleSearch,
    roleFilter,
    handleRoleFilter,
    installationTradeFilter,
    handleInstallationTradeFilter,
    tradeFilterOptions,
    dateRange,
    datePreset,
    handleStartDateChange,
    handleEndDateChange,
    handleDatePreset,
    teamModalOpen,
    openCreateModal,
    openEditEmployee,
    closeModal,
    editingEmployee,
    viewMode,
    setViewMode,
    isLoading,
    handleEmployeeSubmit,
    toggleMemberStatus,
    handlePageChange,
    employees,
    stats,
    page,
    totalPages,
    totalItems,
    toast,
    setToast,
    viewingEmployee,
    setViewingEmployee,
    refetchTeams,
    isExporting,
    handleExport,
  } = useTeams();

  const tableColumns = [
    {
      header: "Employee ID",
      minWidth: "100px",
      accessor: (row) => (
        <span className="text-[11px] font-bold text-slate-700 tracking-wider uppercase">
          {row.employeeId || "—"}
        </span>
      ),
    },
    {
      header: "Employee Name",
      minWidth: "200px",
      accessor: (row) => (
        <div className="flex items-center gap-2.5 min-w-0">
          <div
            className={`w-7 h-7 rounded-full flex items-center justify-center font-bold text-[10px] shrink-0 shadow-sm border ${
              row.status === "Active"
                ? "bg-slate-900 text-white border-slate-700/60"
                : "bg-slate-500 text-white border-slate-600/60"
            }`}
          >
            {row.firstName?.substring(0, 1)?.toUpperCase() || "U"}
          </div>
          <div className="flex flex-col min-w-0">
            <span className="font-semibold text-slate-800 text-[12px] truncate">
              {row.firstName || "Unknown"} {row.lastName || ""}
            </span>
            <span className="text-[11px] text-slate-400 font-medium truncate">
              {row.email || "—"}
            </span>
          </div>
        </div>
      ),
    },
    {
      header: "Role",
      minWidth: "140px",
      accessor: (row) => (
        <div className="flex flex-col gap-0.5">
          {/* <span
            className={`inline-flex w-fit items-center px-2.5 py-0.5 rounded-full border text-[11px] font-medium ${getRoleBadgeStyle(row.role)}`}
          >
            {formatTeamRoleLabel(row.role)}
          </span>
          {row.role === "field_officer" && (
            <span className="text-[9px] font-bold text-slate-400 pl-0.5">
              {formatInstallationTrade(row.installationTrade)}
            </span>
          )} */}
          <span className={`inline-flex w-fit items-center px-2.5 py-0.5 rounded-full border text-[11px] font-medium ${getRoleBadgeStyle(row.role)}`}>
            {row.role === 'field_officer' && row.installationTrade ? formatInstallationTrade(row.installationTrade) : formatTeamRoleLabel(row.role)}
          </span>
        </div>
      ),
    },
    {
      header: "Phone",
      minWidth: "100px",
      accessor: (row) => (
        <span className="text-[12px] font-medium text-slate-600 whitespace-nowrap">
          {row.phone}
        </span>
      ),
    },
    {
      header: "Work Location",
      minWidth: "120px",
      accessor: (row) => (
        <span className="text-[12px] font-medium text-slate-600 truncate block max-w-[140px]">
          {row.workLocation}
        </span>
      ),
    },
    {
      header: "Status",
      minWidth: "100px",
      accessor: (row) => {
        const isActive = row.status === "Active";
        return (
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[11px] font-medium border ${
              isActive
                ? "bg-emerald-50 text-emerald-700 border-emerald-200/30"
                : "bg-slate-50 text-slate-500 border-slate-200/30"
            }`}
          >
            <span
              className={`w-1.5 h-1.5 rounded-full shrink-0 ${isActive ? "bg-emerald-500" : "bg-slate-400"}`}
            />
            {row.status}
          </span>
        );
      },
    },
  ];

  const ActionCell = ({ row }) => {
    // Admin rows should be treated like regular users; status determines inactivity.
    const isInactiveStatus = row.status === "Inactive";
    return (
      <TableActions
        onView={!isInactiveStatus ? () => setViewingEmployee(row) : null}
        onEdit={!isInactiveStatus ? () => openEditEmployee(row) : null}
        onToggle={() => toggleMemberStatus(row)}
        isActive={row.status === "Active"}
        disabled={isInactiveStatus}
      />
    );
  };

  const columnsWithActions = [
    ...tableColumns,
    {
      header: "Actions",
      minWidth: "132px",
      accessor: (row) => <ActionCell row={row} />,
    },
  ];

  return (
    <div className="flex flex-col gap-6 w-full max-w-full pb-12 overflow-x-hidden">
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}

      {/* Brand Hero Banner */}
      <div className="relative overflow-hidden w-full h-32 bg-white border border-slate-200 rounded-xl flex items-center justify-between">
        {/* Left Text */}
        <div className="pl-8 z-20">
          <h1 className="font-serif font-medium text-3xl text-slate-900 tracking-wide">
            Team Management
          </h1>
          <p className="text-sm font-body text-slate-400 mt-2 font-medium">
            Verve Kitchens Executive Portal
          </p>
        </div>

        {/* Right Kitchen Image with gradient fade */}
        <div className="w-[50%] h-full relative overflow-hidden flex-shrink-0">
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/70 to-transparent z-10 w-48" />
          <img
            src="/kitchens/8.jpg"
            alt="Team Management"
            className="absolute top-0 right-0 w-full h-full object-cover object-center"
          />
        </div>
      </div>

      <TeamStats stats={stats} />

      <div className="flex flex-col rounded-2xl overflow-hidden bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] min-w-0">
        <FilterSection
          search={searchQuery}
          setSearch={handleSearch}
          addLabel="Add Team"
          onAddClick={openCreateModal}
          viewStyle={viewMode}
          setViewStyle={setViewMode}
          filters={{
            fromDate: dateRange.from,
            toDate: dateRange.to,
            date: datePreset,
          }}
          setFilters={(key, val) => {
            if (key === "fromDate") handleStartDateChange(val);
            if (key === "toDate") handleEndDateChange(val);
            if (key === "date") handleDatePreset(val);
          }}
          onExport={handleExport}
          isExporting={isExporting}
        >
          {/* Custom Dropdown Filters */}
          <div className="flex items-center gap-2 shrink-0">
            <select
              className="text-[11px] font-bold uppercase tracking-wider bg-white border border-slate-200 hover:border-slate-800 rounded-md px-2.5 py-1.5 focus:outline-none focus:border-slate-800 text-slate-700 min-w-[130px] transition-all cursor-pointer shadow-sm"
              value={roleFilter}
              onChange={(e) => handleRoleFilter(e.target.value)}
            >
              {ROLE_FILTER_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label === "All roles"
                    ? "ROLE: ALL"
                    : opt.label.toUpperCase()}
                </option>
              ))}
            </select>
          </div>
        </FilterSection>
      </div>
      {viewMode === "list" || viewMode === "table" ? (
        <div className="min-w-0 overflow-x-auto">
          <DataTable
            columns={columnsWithActions}
            data={employees}
            backgroundImage={TABLE_BACKGROUNDS.teams}
            isLoading={isLoading}
            isRowInactive={(row) => row.status === "Inactive"}
            getRowClassName={(row) =>
              row.status === "Inactive"
                ? "bg-slate-100/90 border-y border-slate-200/80"
                : "hover:bg-slate-50/50"
            }
          />
        </div>
      ) : (
        <TeamGridView
          data={employees}
          isLoading={isLoading}
          onView={(emp) => setViewingEmployee(emp)}
          onEdit={(emp) => openEditEmployee(emp)}
          onToggleStatus={(emp) => toggleMemberStatus(emp)}
        />
      )}

      <div className="border-t border-slate-50 bg-white">
        <Pagination
          page={page}
          totalPages={totalPages}
          totalItems={totalItems}
          onPageChange={handlePageChange}
        />
      </div>

      {teamModalOpen && (
        <AddEmployeeModal
          key={editingEmployee?._id || "create"}
          isOpen
          onClose={closeModal}
          onSubmit={handleEmployeeSubmit}
          isLoading={isLoading}
          initialData={editingEmployee}
        />
      )}

      <ViewEmployeeModal
        employee={viewingEmployee}
        onClose={() => setViewingEmployee(null)}
        onEmployeeUpdated={(updated) => {
          setViewingEmployee((prev) =>
            prev && updated ? { ...prev, ...updated } : prev,
          );
          refetchTeams();
        }}
      />
    </div>
  );
};
